import Route from 'rise-ui/utils/routing/route.js';

import { action } from '@ember/object';
import { service } from '@ember/service';
import { DEBUG } from '@glimmer/env';
import { storageFor } from 'ember-local-storage';
import { setupTabster } from 'ember-primitives/tabster';

import ENV from 'rise-ui/config/environment.js';
import { isUnset } from 'rise-ui/utils/nullish.js';
import { refresh } from 'rise-ui/utils/query-params.js';

export default class ApplicationRoute extends Route {
  @service ssr;
  @service keywords;
  @service router;
  @service routing;
  @storageFor('debug') debugStorage;

  queryParams = refresh(
    [],
    DEBUG && [ 'debug', 'useCache' ]
  );

  isProduction = !ENV.APP.EXCLUDES?.production;

  constructor() {
    super(...arguments);
    const gtag = globalThis.gtag;
    if (this.isProduction && gtag) {
      const { router } = this;
      router.on('routeDidChange', () => {
        gtag({
          event: 'PageView',
          pagePath: router.currentURL,
          pageTitle: router.currentRouteName || 'unknown',
        });
      });
    }
  }

  async beforeModel(transition) {
    if (DEBUG && !this.ssr.isSsr) {
      const { debug } = transition.to.queryParams;
      const config = this.debugStorage;
      if (debug) {
        config.set('show', true);
        if (isUnset(config.get('enabled'))) {
          config.set('enabled', true);
        }
        if (isUnset(config.get('open'))) {
          config.set('open', true);
        }
      }
    }
    await setupTabster(this);
  }

  async model({ useCache }, transition) {
    this.ssr.useCache = useCache !== 'false';

    if (!transition.to.metadata?.isInvalidRoute) {
      // TODO document: invalid route means it's a hard missing route 404,
      //  not just a missing resource of a given id on a valid route
      // Load only if not a 404
      await this.keywords.load();
    }

    return { isProduction: this.isProduction };
  }

  @action error(error, transition) {
    const notFound = error.message === 'The adapter could not find the resource';
    if (notFound) {
      if (this.ssr.isSsr) {
        this.ssr.setStatus(404);
      }
    }
    return true;
  }
}
